import styled from 'styled-components'

export const NoteCard = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.gray100,
  border: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  borderRadius: theme.border.radius['8'],
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
  padding: theme.space['16'],
}))

export const FormCard = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['8'],
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
  padding: theme.space['16'],
}))
